import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Handleapproveapifund(state = initialState, action) {
  switch (action.type) {
    case userConstants.HANDLEAPPROVEAPIFUND_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.HANDLEAPPROVEAPIFUND_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.HANDLEAPPROVEAPIFUND_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}